/* Files or a description dropped on Hjem travel to /ny in memory – the conversation page picks them up once. */
let pending = null;

export const stashIntake = (payload) => { pending = payload; };
export const takeIntake = () => { const p = pending; pending = null; return p; };
